import { InjectionToken, Signal } from '@angular/core';

/** Minimal contract a TabPanel needs from its parent TabsComponent. */
export interface TabsParent {
  /** Currently active tab id. */
  activeTab: Signal<string>;
}

/** Injection token so child `TabPanelComponent`s can read the active tab signal. */
export const TABS_PARENT = new InjectionToken<TabsParent>('TABS_PARENT');
